import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import useZygoatEnvVariables from 'hooks/query-hooks/useZygoatEnvVariables';

import { NAV_CONFIRMATION_ABORT_MESSAGE } from 'utils/constants/navigation';
import tokenFetcher, { withReturn } from 'zg_utils/tokens';

const isSsr = typeof window === 'undefined';

// Percentage of trace samples we send to sentry
const DEFAULT_SAMPLING_RATE = 0.1;

const ZygoatEnvDataLoader = () => {
  const { data, isLoading } = useZygoatEnvVariables();

  useEffect(() => {
    if (!isSsr && !isLoading && data) {
      // Once the zygoat data is fetched, initialize Sentry and the token fetcher.
      if (data.sentryDsn) {
        Sentry.init({
          dsn: data.sentryDsn,
          environment: data.sentryEnvironment,
          integrations: [Sentry.browserTracingIntegration()],
          // Intentional route cancellations from the nav confirmation modal surface as
          // unhandled promise rejections from router.push (e.g. Link clicks, back button).
          ignoreErrors: [NAV_CONFIRMATION_ABORT_MESSAGE],
          tracesSampler: ({ name, inheritOrSampleWith }) => {
            // Record all traces on the submit-claim page
            if (name.includes('/submit-claim')) {
              return 1.0;
            }

            return inheritOrSampleWith(DEFAULT_SAMPLING_RATE);
          },
        });
      }
      if (data.portunusUrl) {
        const onErrorHandler = () => {
          window.location.replace(withReturn(`${data.portunusUrl}/login`));
        };
        tokenFetcher.start(data.portunusUrl, null, null, onErrorHandler);
      }
    }
  }, [data, isLoading]);

  useEffect(() => {
    return () => tokenFetcher.clearToken();
  }, []);

  return null;
};

export default ZygoatEnvDataLoader;
